<template>
  <ul class="wrapper">
    <!-- 遍历 router 菜单数据 -->
    <treeitem :key="index" v-for="(item, index) in router">
      <!-- 对于没有 children 子菜单的 item -->
      <span class="item-title" v-if="!item.children">{{ item.name }} no children</span>

      <!-- 对于有 children 子菜单的 item -->
      <template v-else>
        <span @click="handleToggleShow">{{ item.name }} show children</span>
        <!-- 递归操作 -->
        <tree :router="item.children" v-if="toggleShow"></tree>
      </template>
    </treeitem>
  </ul>
</template>

<script>
import TreeItem from "./TreeItem";

export default {
  name: "Tree",
  props: ["router"], // Tree 组件接受一个 router 作为菜单数据
  components: { TreeItem },
  data() {
    return {
      toggleShow: false // toggle 状态
    };
  },
  methods: {
    handleToggleShow() {
      // 处理 toggle 状态的是否展开子菜单 handler
      this.toggleShow = !this.toggleShow;
    }
  }
};
</script>

<style lang="less" scoped>
.wrapper {
  cursor: pointer;

  .item-title {
    font-size: 16px;
  }

  treeitem {
    display: block;
  }
}
</style>